import { Button } from '../../cdl/Button/Button';
import { StatePlaceholder } from '../../cdl/StatePlaceholder/StatePlaceholder';
import { translate } from '../../common/helpers/translate.helper';
import { useOpenFreshchat } from '../../common/hooks/useOpenFreshchat';
import { IconAlertTriangle } from '../../common/icons/cdl/AlertTriangle';
import { Box } from '../../common/ui/Box';

import { DemandFlowStatusOverlay } from './DemandFlowStatusOverlay';

interface DemandDraftSaveErrorOverlayProps {
    isRetrying: boolean;
    onRetry: () => void;
    onKeepEditing: () => void;
    onClose: () => void;
}

export const DemandDraftSaveErrorOverlay = ({
    isRetrying,
    onRetry,
    onKeepEditing,
    onClose,
}: DemandDraftSaveErrorOverlayProps) => {
    const openFreshchat = useOpenFreshchat();

    return (
        <DemandFlowStatusOverlay>
            <Box width="100%" maxWidth="420px">
                <StatePlaceholder
                    title={translate('demandDefinition.draftSaveFailedTitle')}
                    description={translate('demandDefinition.draftSaveFailedDescription')}
                    Icon={IconAlertTriangle}
                    action={
                        <Box display="flex" flexWrap="wrap" gap={8}>
                            <Button emphasis="high" onClick={onRetry} isLoading={isRetrying}>
                                {translate('demandDefinition.retrySavingDraft')}
                            </Button>
                            <Button onClick={openFreshchat} disabled={isRetrying}>
                                {translate('error.public.contactSupport')}
                            </Button>
                            <Button emphasis="low" onClick={onKeepEditing} disabled={isRetrying}>
                                {translate('drawer.keepEditing')}
                            </Button>
                            <Button emphasis="low" onClick={onClose} disabled={isRetrying}>
                                {translate('global.close')}
                            </Button>
                        </Box>
                    }
                />
            </Box>
        </DemandFlowStatusOverlay>
    );
};
